import { CommonWork } from '../CommonWork'
import { List } from '../List'

export class CooperationInformationParent extends List {
  constructor(obj) {
    super(CooperationInformation, obj)
  }
}

export class CooperationInformation {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.department = obj?.department || null
    this.cooperationType = obj?.cooperationType || null
    this.scientistName = obj?.scientistName || null
    this.birthYear = obj?.birthYear || null
    this.country = obj?.country || null
    this.foreignOrganization = obj?.foreignOrganization || null
    this.organizationNamePlan = obj?.organizationNamePlan || null
    this.organizationName = obj?.organizationName || null
    this.cooperationFormat = obj?.cooperationFormat || null
    this.scientificDirection = obj?.scientificDirection || null
    this.priorityArea = obj?.priorityArea || null
    this.interactionType = obj?.interactionType || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      department: this.department,
      cooperationType: this.cooperationType,
      scientistName: this.scientistName,
      birthYear: this.birthYear,
      country: this.country,
      foreignOrganization: this.foreignOrganization,
      organizationNamePlan: this.organizationNamePlan,
      organizationName: this.organizationName,
      cooperationFormat: this.cooperationFormat,
      scientificDirection: this.scientificDirection,
      priorityArea: this.priorityArea,
      interactionType: this.interactionType
    }
  }

  getCooperationTypeWithScientistForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      department: this.department,
      cooperationType: this.cooperationType,
      scientistName: this.scientistName,
      birthYear: this.birthYear,
      country: this.country,
      organizationName: this.organizationName,
      cooperationFormat: this.cooperationFormat,
      scientificDirection: this.scientificDirection,
      interactionType: this.interactionType
    }
  }

  getCooperationTypeWithPartnerForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      department: this.department,
      cooperationType: this.cooperationType,
      country: this.country,
      foreignOrganization: this.foreignOrganization,
      organizationNamePlan: this.organizationNamePlan,
      scientificDirection: this.scientificDirection,
      priorityArea: this.priorityArea,
      interactionType: this.interactionType
    }
  }
}
